export default "__VITE_ASSET__fac8386c__"